import { ActionReducer } from '@ngrx/store';
import { AccountGroup } from '../model/account-group/account-group.model';

const toggleAccountGroup: ActionReducer<AccountGroup> = (state: AccountGroup, {payload}: any) => {
    // compare by id if possible, compare by name otherwise
    if (!!state.id && payload.accountGroup.id) {
        if (state.id !== payload.accountGroup.id) {
            return state;
        }
    } else {
        if (state.name !== payload.accountGroup.name) {
            return state;
        }
    }

    return {...state, shown: !state.shown};
};

export const toggleAccountGroups: ActionReducer<AccountGroup[]> = (state: AccountGroup[], action: any) => {
    return state.map(g => toggleAccountGroup(g, action));
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/core/reducers/toggle-account-groups.reducer.ts